import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useMemo, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CustomRedirect } from '@/components/functional/Link/CustomRedirect/CustomRedirect';
import { propMatch } from '@/helpers/custom-prop-types';
import { apiGetOneProfessionalSeminar } from '../../../../actions/ProfessionalSeminarActions';
import { wrapDispatch } from '../../../../helpers/action';
const SeminarHoc = (setting, ChildSkeletonComponent) => (ChildComponent) => {
    const SeminarHocInner = (props) => {
        const { redirectCallback } = setting;
        const { match: { params: { id }, }, } = props;
        const [loading, changeLoading] = useState(!!id);
        const dispatch = useDispatch();
        const seminar = useSelector((state) => state.professionalSeminar.one[id]);
        const profile = useSelector((state) => state.profile);
        const pageTitle = `セミナー${id ? '編集' : '追加'}`;
        const pans = useMemo(() => [
            {
                link: '/mypage',
                text: 'マイページ',
            },
            {
                link: '',
                text: pageTitle,
            },
        ], [pageTitle]);
        const redirectTo = useMemo(() => {
            if (!loading && !seminar && id)
                return '/error/notfound';
            if (seminar && redirectCallback)
                return redirectCallback(seminar);
            return '';
        }, [id, seminar, loading, redirectCallback]);
        useEffect(() => {
            let unmount = false;
            if (id) {
                changeLoading(true);
                wrapDispatch(dispatch, apiGetOneProfessionalSeminar(id, { id })).finally(() => {
                    if (!unmount) {
                        changeLoading(false);
                    }
                });
            }
            return () => {
                unmount = true;
            };
        }, [id, dispatch, changeLoading]);
        if (redirectTo) {
            return _jsx(CustomRedirect, { to: redirectTo });
        }
        if (loading && !seminar) {
            return _jsx(ChildSkeletonComponent, { pageTitle: pageTitle, pans: pans });
        }
        return (_jsx(ChildComponent, Object.assign({}, props, { id: id, pageTitle: pageTitle, pans: pans, profile: profile, seminar: seminar })));
    };
    SeminarHocInner.propTypes = {
        match: propMatch(),
    };
    return SeminarHocInner;
};
export default SeminarHoc;
